/**
 * yd-cine-hero: 电影级滚动首幕驱动（无外部库）。
 *
 * 1) 命题 [data-split]（layer2）逐字拆分，进场时按 --intro 进度逐字浮现。
 * 2) 在 .cine__stage 写 CSS 变量：--intro · --s1 LOGO 退场 · --s2 图提亮放大 · --s3 命题进 · --hint。
 * 3) 首屏隐藏导航（body.nav-hidden），下滑出现；暗场覆盖顶部时导航反色（body.is-cine-top）。
 * 尊重 prefers-reduced-motion（静态首帧）。幂等；DOMContentLoaded / load / shopify:section:load 后初始化。
 * 源自 web-hand-off/cla/assets/js/cine-hero.js：删 partials:loaded，补 shopify:section:load。
 */
(function () {
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };

  function splitChars(scope) {
    var chars = [];
    if (!scope) return chars;
    scope.querySelectorAll('[data-split]').forEach(function (el) {
      if (el.dataset.splitDone) { el.classList.add('is-split'); el.querySelectorAll('.cine__ch').forEach(function (c) { chars.push(c); }); return; }
      var s = el.textContent; el.textContent = '';
      for (var i = 0; i < s.length; i++) {
        var sp = document.createElement('span');
        if (s[i] === ' ') { sp.className = 'cine__ch cine__ch--sp'; sp.innerHTML = '&nbsp;'; }
        else { sp.className = 'cine__ch'; sp.textContent = s[i]; }
        el.appendChild(sp); chars.push(sp);
      }
      el.dataset.splitDone = '1';
      // 拆字完成，整行可见性移交内部 .cine__ch（防拆字前整句以可见态闪现）
      el.classList.add('is-split');
    });
    return chars;
  }

  function reveal(chars, p) {
    var n = Math.floor(p * chars.length);
    for (var i = 0; i < chars.length; i++) chars[i].classList.toggle('is-on', i < n);
  }

  function setup(section) {
    if (section.dataset.cineReady) return;
    section.dataset.cineReady = '1';
    var stage = section.querySelector('.cine__stage');
    if (!stage) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var thesisChars = splitChars(section.querySelector('.cine__layer--2'));
    var set = function (k, v) { stage.style.setProperty(k, String(v)); };

    if (reduced) {
      section.classList.add('is-static'); set('--intro', 1);
      thesisChars.forEach(function (c) { c.classList.add('is-on'); });
    } else {
      var dur = 1500, start = null;
      var step = function (ts) {
        if (start === null) start = ts;
        var t = clamp01((ts - start) / dur);
        set('--intro', easeOut(t).toFixed(4));
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var navH = 80, dark = false;
        if (document.elementsFromPoint) {
          var els = document.elementsFromPoint(window.innerWidth / 2, 48);
          for (var i = 0; i < els.length; i++) {
            if (els[i].closest && els[i].closest('.nav')) continue;
            dark = !!(els[i].closest && els[i].closest('[data-dark-nav]'));
            break;
          }
        } else {
          document.querySelectorAll('[data-dark-nav]').forEach(function (s) {
            var r = s.getBoundingClientRect();
            if (r.top <= navH && r.bottom > navH) dark = true;
          });
        }
        document.body.classList.toggle('is-cine-top', dark);
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = rect.height - vh;
        var p = total > 0 ? clamp01(-rect.top / total) : 0;
        document.body.classList.toggle('nav-hidden', p < 0.035);
        if (reduced) return;
        set('--s1', clamp01(p / 0.16).toFixed(4));
        set('--s2', clamp01(p / 0.34).toFixed(4));
        var s3 = clamp01((p - 0.08) / 0.18);
        set('--s3', s3.toFixed(4));
        set('--hint', clamp01(p / 0.05).toFixed(4));
        reveal(thesisChars, s3);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  function init() { document.querySelectorAll('[data-cine]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
